<template>
    <div class="btn-hamburger" @click="$emit('click')"><span></span><slot /></div>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
// hamburger
.btn-hamburger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: calc(var(--btn-hamburger-width) + 8px);
    height: calc(var(--btn-hamburger-width) + 8px);
    z-index: 6;
    cursor: pointer;
    color: rgba(var(--btn-hamburger-color), var(--btn-hamburger-color-opacity));
    > span {
        position: relative;
        &,
        &::before,
        &::after {
            display: block;
            width: var(--btn-hamburger-width);
            height: var(--btn-hamburger-height);
            background-color: currentColor;
        }
        &::before,
        &::after {
            position: absolute;
            content: "";
            transition-property: margin, transform;
            transition-duration: 0.2s;
        }
        &::before {
            margin-top: -8px;
        }
        &::after {
            margin-top: 8px;
        }
    }

    &.active {
        > span {
            background-color: rgba(0, 0, 0, 0);
            transition-delay: 0.2s;
            &::before,
            &::after {
                left: auto;
                right: auto;
                margin-top: 0;
                transition-delay: 0s, 0.2s;
            }
            &::before {
                transform: rotate(45deg);
            }
            &::after {
                transform: rotate(-45deg);
            }
        }
    }

    &--pc {
        display: none;
    }
    &--mobile {
        display: inline-flex;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 6;
        width: var(--header-body-height);
        height: var(--header-body-height);
    }

    &--light {
        color: rgba(255, 255, 255, 1);
    }
}
.scroll-active,
.mobile-menu-on{
    .btn-hamburger--light{
        color: var(--v-grey-darken4);
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
    .btn-hamburger {
        &--pc {
            display: inline-flex;
        }
        &--mobile {
            display: none;
        }
    }
}
</style>
